import React from 'react';
import { HiArrowNarrowRight } from 'react-icons/hi';
import { Link } from "react-scroll";

const Home = () => {
  return (
    <div name='home' className='w-full h-screen bg-[#0a192f]'>
      {/* Container */}
      <div className='max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full'>
        <p className='text-[#ccd6f6]'>Hi, my name is</p>
        <h1 className='text-4xl sm:text-7xl font-bold text-[#ccd6f6]'>
          JOSIAS KABORE
        </h1>
        <p className="text-2xl sm:text-2xl  font-bold text-[#8892b0] font-weight: 100 sm:py-8">
          I'M <b>INSPIRED</b> BY DESIGNING CREATIVE SOLUTIONS TO SOLVE PROBLEMS.
        </p>
        <p className='text-[#8892b0] py-4 max-w-[700px]'>
        I got into software development because I wanted to create and inspire
          positive change in the world. The process of taking an idea and
          building something tangible for others to use and benefit from is
          something I love doing. I have a strong foundation in front-end &
          back-end development and am skilled in creating user-friendly and
          responsive web applications using React and its ecosystem.
        </p>
        <div>
        <Link to="work" smooth={true} duration={500} activeStyle>
          <button className='text-white group border-2 px-6 py-3 my-2 flex items-center  hover:bg-[#9ca3af] hover:border[#9ca3af]'>
            View Work
            <span className='group-hover:rotate-90 duration-300'>
              <HiArrowNarrowRight className='ml-3 ' />
            </span>
          </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
